// import React, { useState, useEffect } from 'react';
// import { useParams } from 'react-router-dom';
// import {
//   Container,
//   Typography,
//   Box,
//   CircularProgress,
//   Button,
//   Divider,
//   Card,
//   CardContent,
//   CardActions,
//   Grid,
//   Paper,
//   styled,
// } from '@mui/material';
// import { authService } from '../features/user/userService';
// import { toast } from 'react-toastify';
// import { base_url } from '../utils/axiosConfig';

// // Styled components for enhanced design
// const StyledCard = styled(Card)(({ theme }) => ({
//   borderRadius: '12px',
//   boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
//   background: 'linear-gradient(145deg, #ffffff, #f9f9f9)',
//   transition: 'transform 0.3s ease, box-shadow 0.3s ease',
//   '&:hover': {
//     transform: 'translateY(-5px)',
//     boxShadow: '0 8px 30px rgba(0, 0, 0, 0.15)',
//   },
//   marginBottom: theme.spacing(4),
// }));

// const StyledButton = styled(Button)(({ theme }) => ({
//   background: 'linear-gradient(45deg, #1976d2, #2196f3)',
//   color: '#fff',
//   padding: theme.spacing(1.5, 4),
//   borderRadius: '8px',
//   textTransform: 'none',
//   fontWeight: 600,
//   fontSize: '1rem',
//   boxShadow: '0 3px 10px rgba(25, 118, 210, 0.3)',
//   transition: 'background 0.3s ease, transform 0.2s ease',
//   '&:hover': {
//     background: 'linear-gradient(45deg, #1565c0, #1e88e5)',
//     transform: 'scale(1.05)',
//   },
//   '&:disabled': {
//     background: '#b0bec5',
//     color: '#fff',
//     boxShadow: 'none',
//   },
// }));

// const StyledItemCard = styled(Paper)(({ theme }) => ({
//   display: 'flex',
//   alignItems: 'center',
//   padding: theme.spacing(2),
//   borderRadius: '10px',
//   background: '#fff',
//   boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
//   marginBottom: theme.spacing(2),
//   transition: 'background 0.2s ease',
//   '&:hover': {
//     background: '#f5f5f5',
//   },
// }));

// const TitleTypography = styled(Typography)(({ theme }) => ({
//   fontWeight: 700,
//   color: theme.palette.primary.dark,
//   marginBottom: theme.spacing(2),
// }));

// const OrderDetails = () => {
//   const { id } = useParams();
//   const [order, setOrder] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [repeating, setRepeating] = useState(false);

//   useEffect(() => {
//     const fetchOrder = async () => {
//       try {
//         const response = await authService.getOrderById(id);
//         setOrder(response.order);
//       } catch (error) {
//         console.error('Fetch order error:', error);
//         toast.error(error.message || 'Failed to fetch order details');
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchOrder();
//   }, [id]);

//   const handleRepeatOrder = async () => {
//     setRepeating(true);
//     try {
//       const orderData = {
//         shippingInfo: {
//           firstName: order.shippingInfo.firstName,
//           lastName: order.shippingInfo.lastName,
//           address: order.shippingInfo.address,
//           city: order.shippingInfo.city,
//           state: order.shippingInfo.state,
//           landmark: order.shippingInfo.landmark || '',
//           pincode: order.shippingInfo.pincode,
//         },
//         orderItems: order.orderItems.map(item => ({
//           product: item.product._id,
//           quantity: item.quantity,
//           price: item.price,
//         })),
//         totalPrice: order.totalPrice,
//         paymentInfo: {
//           cashOndelivery: order.paymentInfo?.cashOndelivery,
//         },
//       };
//       const response = await authService.repeatOrder(orderData);
//       toast.success(`Order repeated successfully! New Order ID: ${response.order._id}`);
//     } catch (error) {
//       console.error('Repeat order error:', error);
//       toast.error(error.message || 'Failed to repeat order');
//     } finally {
//       setRepeating(false);
//     }
//   };

//   if (loading) {
//     return (
//       <Box display="flex" justifyContent="center" alignItems="center" minHeight="70vh">
//         <CircularProgress size={60} thickness={4} color="primary" />
//       </Box>
//     );
//   }

//   if (!order) {
//     return (
//       <Container maxWidth="md" sx={{ py: 8, textAlign: 'center' }}>
//         <Paper elevation={3} sx={{ p: 4, borderRadius: '12px' }}>
//           <Typography variant="h5" color="text.secondary">
//             Order Not Found
//           </Typography>
//           <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
//             The order you’re looking for doesn’t exist or has been removed.
//           </Typography>
//         </Paper>
//       </Container>
//     );
//   }

//   return (
//     <Container maxWidth="lg" sx={{ py: 6 }}>
//       <TitleTypography variant="h4">
//         Order Details :
//       </TitleTypography>

//       {/* Order Information */}
//       <StyledCard>
//         <CardContent>
//           <Typography variant="h6" color="primary" fontWeight="bold">
//             Order Information
//           </Typography>
//           <Divider sx={{ my: 2 }} />
//           <Grid container spacing={2}>
//             <Grid item xs={12} sm={6}>

//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <Typography variant="body1">
//                 <strong>Total:</strong> ${order.totalPrice?.toFixed(2) || '0.00'}
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <Typography variant="body1">
//                 <strong>Status:</strong> {order.orderStatus || 'N/A'}
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <Typography variant="body1">
//                 <strong>Payment:</strong> {order.paymentInfo?.cashOndelivery ? 'Cash on Delivery' : 'N/A'}
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <Typography variant="body1">
//                 <strong>Ordered On:</strong>{' '}
//                 {new Date(order.createdAt).toLocaleDateString('en-US', {
//                   month: 'short',
//                   day: 'numeric',
//                   year: 'numeric',
//                 })}
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <Typography variant="body1">
//                 <strong>Tracking Number:</strong> {order.trackingNumber || 'N/A'}
//               </Typography>
//             </Grid>
//           </Grid>
//         </CardContent>
//       </StyledCard>

//       {/* Shipping Information */}
//       <StyledCard>
//         <CardContent>
//           <Typography variant="h6" color="primary" fontWeight="bold">
//             Shipping Information
//           </Typography>
//           <Divider sx={{ my: 2 }} />
//           <Grid container spacing={2}>
//             <Grid item xs={12} sm={6}>
//               <Typography variant="body1">
//                 <strong>Name:</strong> {order.shippingInfo?.firstName} {order.shippingInfo?.lastName}
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <Typography variant="body1">
//                 <strong>Address:</strong> {order.shippingInfo?.address}
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <Typography variant="body1">
//                 <strong>City:</strong> {order.shippingInfo?.city}
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <Typography variant="body1">
//                 <strong>State:</strong> {order.shippingInfo?.state}
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <Typography variant="body1">
//                 <strong>Landmark:</strong> {order.shippingInfo?.landmark || 'N/A'}
//               </Typography>
//             </Grid>
//             <Grid item xs={12} sm={6}>
//               <Typography variant="body1">
//                 <strong>Pincode:</strong> {order.shippingInfo?.pincode}
//               </Typography>
//             </Grid>
//           </Grid>
//         </CardContent>
//       </StyledCard>

//       {/* Order Items */}
//       <StyledCard>
//         <CardContent>
//           <Typography variant="h6" color="primary" fontWeight="bold">
//             Order Items
//           </Typography>
//           <Divider sx={{ my: 2 }} />
//           {order.orderItems.map((item) => (
//             <StyledItemCard key={item._id} elevation={1}>
//               {item.product?.images[0]?.url && (
//                 <img
//                 src={`${base_url}${item.product.images[0].url}`}   

//                   alt={item.product.title || 'Product'}
//                   style={{
//                     width: 80,
//                     height: 80,
//                     borderRadius: '8px',
//                     marginRight: 16,
//                     objectFit: 'cover',
//                   }}
//                 />
//               )}
//               <Box flexGrow={1}>
//                 <Typography variant="subtitle1" fontWeight="bold">
//                   {item.product?.title || 'Unknown'}
//                 </Typography>
//                 <Typography variant="body2" color="text.secondary">
//                   Product ID: {item.product?._id || 'Unknown'}
//                 </Typography>
//                 <Typography
//                   variant="body2"
//                   color="text.secondary"
//                   sx={{ mt: 1, maxWidth: '600px', lineHeight: 1.5 }}
//                 >
//                   {item.product?.description || 'No description available'}
//                 </Typography>
//                 <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
//                   Quantity: {item.quantity} | Price: ${item.price?.toFixed(2)}
//                 </Typography>
//               </Box>
//             </StyledItemCard>
//           ))}
//         </CardContent>
//       </StyledCard>

//       {/* Repeat Order Button */}
//       <CardActions sx={{ justifyContent: 'center', mt: 4 }}>
//         <StyledButton
//           onClick={handleRepeatOrder}
//           disabled={repeating || !order}
//           startIcon={repeating && <CircularProgress size={20} color="inherit" />}
//         >
//           {repeating ? 'Repeating...' : 'Repeat Order'}
//         </StyledButton>
//       </CardActions>
//     </Container>
//   );
// };

// export default OrderDetails;


import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Box,
  CircularProgress,
  Button,
  Card,
  CardContent,
  Divider,
  IconButton,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { authService } from '../features/user/userService';
import { getUserCart } from '../features/user/userSlice';
import { base_url } from '../utils/axiosConfig';
import axios from 'axios';

const OrderDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.auth);
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [repeating, setRepeating] = useState(false);
  const [cancelling, setCancelling] = useState(false);
  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
  const [cancelReason, setCancelReason] = useState('');

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const response = await authService.getOrderById(id);
        setOrder(response.order);
      } catch (error) {
        toast.error('Failed to fetch order details');
      } finally {
        setLoading(false);
      }
    };
    fetchOrder();
  }, [id]);

  const handleRepeatOrder = async () => {
    setRepeating(true);
    try {
      if (isAuthenticated) {
        for (const item of order.orderItems) {
          await authService.addToCart({
            ProductId: item.product._id,
            quantity: item.quantity,
            price: item.price,
          });
        }
        await dispatch(getUserCart());
        toast.success('Items added to cart');
      } else {
        let localCart = JSON.parse(localStorage.getItem('cart')) || [];
        order.orderItems.forEach((item) => {
          const index = localCart.findIndex((i) => i.ProductId._id === item.product._id);
          if (index >= 0) localCart[index].quantity += item.quantity;
          else localCart.push({ ProductId: item.product, price: item.price, quantity: item.quantity });
        });
        localStorage.setItem('cart', JSON.stringify(localCart));
        toast.success('Items added to local cart');
      }
      navigate('/cart');
    } catch {
      toast.error('Failed to add items to cart');
    } finally {
      setRepeating(false);
    }
  };

  const handleCancelOrder = async () => {
    if (!cancelReason.trim()) return toast.error('Provide a cancellation reason');
    setCancelling(true);
    try {
      const token = JSON.parse(localStorage.getItem('customer'))?.token;
      if (!token) throw new Error('Authentication required');
      const res = await axios.put(`${base_url}user/cancelorder/${id}`, { reason: cancelReason }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.data.success) {
        setOrder({ ...order, orderStatus: 'Cancelled', cancellationReason: cancelReason });
        toast.success('Order cancelled');
        setCancelDialogOpen(false);
        setCancelReason('');
      } else toast.error(res.data.message);
    } catch (err) {
      toast.error(err.message || 'Cancel failed');
    } finally {
      setCancelling(false);
    }
  };

  if (loading) return <Box display="flex" justifyContent="center" minHeight="60vh"><CircularProgress /></Box>;

  if (!order) return <Container><Typography>Order Not Found</Typography></Container>;

  return (
    <Container maxWidth="md" sx={{ py: 2 }}>
      {/* Header */}
      <Box display="flex" alignItems="center" mb={2}>
  <Button 
    variant="text" 
    startIcon={<ArrowBackIcon />} 
    onClick={() => navigate(-1)}
  >
    Back
  </Button>
</Box>


      {/* Order Summary */}
      <Card variant="outlined" sx={{ p: 2, mb: 2 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
  <Typography variant="subtitle1">
    <b>Tracking Number</b>: <b>{order.trackingNumber}</b>
  </Typography>
  <Box>
    <Typography variant="subtitle1">
  Order Status: <b style={{ color: order.orderStatus === 'Cancelled' ? 'red' : order.orderStatus === 'Return' ? 'orange' : 'green' }}>
    {order.orderStatus}
  </b>
</Typography>
    {/* Show return reason if status is Return */}
    {order.orderStatus === 'Return' && order.returnReason && (
      <Typography variant="body2" color="warning.main">
        Return Reason: {order.returnReason}
      </Typography>
    )}

    {order.cancellationReason && <Typography variant="body2" color="error">Cancelled Reason: {order.cancellationReason}</Typography>}
  </Box>
</Box>


        <Typography variant="body2">
  <b>Ordered Date:</b> {new Date(order.createdAt).toLocaleString()}
</Typography>

<Typography variant="body2">
  <b>Payment:</b> {order.paymentInfo?.cashOndelivery ? 'Cash on Delivery' : 'Online'}
</Typography>

<Typography variant="body2">
  <b>Delivery Instructions:</b> {order.deliveryInstruction || 'N/A'}
</Typography>

        
        
        <Divider sx={{ my: 1 }} />

        {/* Customer Info */}
        <Typography variant="subtitle2">Customer:</Typography>
        <Typography variant="body2">{order.user?.email}</Typography>

        {/* Shipping Info */}
        <Typography variant="subtitle2" sx={{ mt: 1 }}>Shipping Address:</Typography>
        <Typography variant="body2">
          {order.shippingInfo?.address}, {order.shippingInfo?.landmark}<br />
          {order.shippingInfo?.city}, {order.shippingInfo?.state} - {order.shippingInfo?.pincode}
        </Typography>
      </Card>

      {/* Order Items */}
      <Typography variant="h6" gutterBottom>Items</Typography>
      {order.orderItems?.map((item) => (
  <Card key={item._id} variant="outlined" sx={{ mb: 1, p: 1, display: 'flex', alignItems: 'center' }}>
    <Box
      component="img"
      src={item.product?.images?.[0]?.url ? `${base_url}${item.product.images[0].url}` : '/default.jpg'}
      alt={item.product?.title || 'Product'}
      sx={{ width: 60, height: 60, objectFit: 'cover', borderRadius: 1, mr: 2 }}
    />
    <Box>
      <Typography variant="body2" fontWeight={600}>{item.product?.title || 'Product'}</Typography>
      <Typography variant="caption">Qty: {item.quantity} | Price: ₹{item.price?.toFixed(2) || 0}</Typography>
    </Box>
  </Card>
))}


      {/* Totals */}
      <Box textAlign="right" mt={2}>
        <Typography variant="h6">Total: ₹{order.totalPrice.toFixed(2)}</Typography>
      </Box>

      {/* Actions */}
<Box display="flex" justifyContent="flex-end" gap={2} mt={3} flexWrap="wrap">
  <Button 
    variant="contained" 
    onClick={handleRepeatOrder} 
    disabled={repeating || order.orderStatus === 'Cancelled'}
  >
    {repeating ? 'Adding...' : 'Repeat Order'}
  </Button>

  {/* Only show Cancel button if status is NOT Cancelled or Return */}
  {order.orderStatus !== 'Cancelled' && order.orderStatus !== 'Return' && (
    <Button 
      variant="outlined" 
      color="error" 
      onClick={() => setCancelDialogOpen(true)}
    >
      Cancel Order
    </Button>
  )}
</Box>


      {/* Cancel Dialog */}
      <Dialog
  open={cancelDialogOpen}
  onClose={() => setCancelDialogOpen(false)}
  fullWidth
  maxWidth="sm"
>
  <DialogTitle>Cancel Order</DialogTitle>
  
  <DialogContent sx={{ mt: 1, pb: 2 }}>
    <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "bold" }}>
      Reason for Cancellation
    </Typography>
    <TextField
      placeholder="Enter reason here..."
      fullWidth
      multiline
      minRows={3}
      value={cancelReason}
      onChange={(e) => setCancelReason(e.target.value)}
      disabled={cancelling}
      autoFocus
    />
  </DialogContent>
  
  <DialogActions sx={{ pr: 3, pb: 2 }}>
    <Button 
      onClick={() => setCancelDialogOpen(false)} 
      disabled={cancelling}
      color="inherit"
    >
      Close
    </Button>
    <Button 
      onClick={handleCancelOrder} 
      disabled={!cancelReason.trim() || cancelling} 
      variant="contained" 
      color="error"
    >
      {cancelling ? 'Cancelling...' : 'Confirm'}
    </Button>
  </DialogActions>
</Dialog>

    </Container>
  );
};

export default OrderDetails;
